import React, { useEffect, useRef, useState, useCallback } from "react";
import _ from "lodash";
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Row,
    Col
} from "reactstrap";
// core components
import { withTranslation } from "react-i18next";
import { useForm } from "react-hook-form"
// import CommonFields from "../fields/shared/CommonFields";
import UnitFields from "../fields/";
import UIDs from "../../../../UIDs";
//import { helpers } from "chart.js";
import { ImageField } from "../fields/types";
import MessageBox from "../../../../components/ui/MessageBox";
import { Sticky } from "react-sticky";
import { LocalizableTextField } from "../fields/types";
import * as Helper from "../../../../utils/Helper";

const uid = UIDs.screens.admin.unit.forms.simpleunitform;

let t;

const SimpleUnitForm = (props) => {
    t = props.t;

    //form hook helper func
    const formMethods = useForm();
    const { register } = formMethods

    const { unitType, formData, commonFieldValues, id } = props.data;

    const [state_unitType, setstate_unitType] = useState(unitType + " " + props.t("unit"));
    const [state_oldUnitType, setstate_oldUnitType] = useState(unitType + " " + props.t("unit"));
    const [state_display, setstate_display] = useState("");
    useEffect(() => {
        if(unitType === "PSZM1"){
            if(formData && formData.answerType){
                if(formData.answerType === 8){
                    setstate_unitType(t("photo"))
                    setstate_oldUnitType(t("photo"))
                }
                else if(formData.answerType === 4){
                    setstate_unitType(t("audio"))
                    setstate_oldUnitType(t("audio"))
                }
            }
        } else if(unitType === "POKA2") {
            setstate_unitType(t("reading"))
            setstate_oldUnitType(t("reading"))
        }
    }, [formData]);

    const isCompositeUnit = ('CP' === unitType);
    const EditFields = UnitFields[unitType];

    const onSave = newFormData => {
        var buildFieldsData = EditFields.buildFieldsData;
        if (!buildFieldsData) {
            // due to translation wrapper
            buildFieldsData = EditFields.WrappedComponent.buildFieldsData;
        }

        let fieldsData = {};
        try {
            fieldsData = buildFieldsData(newFormData)
        } catch (e) {
            MessageBox.danger({ text: e.message, duration: 5000 });
            return;
        }

        if (fieldsData.data && _.isPlainObject(fieldsData.data)){
            if (!isCompositeUnit) {
                fieldsData.data = {
                    ...fieldsData.data,
                    title: Helper.combineTranslation(newFormData, "title"),
                }
            }
        }

        let duration = newFormData.duration;
        if (isCompositeUnit) {
            // 复合单元duration为所有子单元的duration相加
            duration = 0;
            fieldsData.data.units.forEach((subUnit) => {
                duration += 30;
            });
        }

        let submitData = {
            ...fieldsData,
            commonFieldValues: {
                duration: 30,
                cover: newFormData.cover,
            }
        }

        props.onSave(submitData);
    };

    const onNextButton = () => {
        setstate_unitType(t("nextTitle"));
        setstate_display("none");
    }

    const onBackButton = () => {
        setstate_unitType(state_oldUnitType);
        setstate_display("");
    }

    return (
        <form id="unitForm">
            <Card className="shadow">
                <CardHeader className="bg-white border-0" style={{ zIndex: 1 }}>
                    <Sticky>
                        {({
                            style,
                            distanceFromTop
                        }) => (
                                <div style={style}>
                                    <div className="align-items-center" style={{
                                        height: "100%",
                                        background: "#ffffff",
                                        borderBottom: `${distanceFromTop && distanceFromTop <= 0 ? "1px solid #E4E4E4" : "1px solid #ffffff"}`
                                    }}
                                    >
                                        <Row>
                                            <Col xs="7" style={{ marginTop: distanceFromTop && distanceFromTop <= 0 ? 20 : 0, marginBottom: distanceFromTop && distanceFromTop <= 0 ? 20 : 0 }}>
                                                <h3 className="mb-0">{state_unitType}</h3>
                                            </Col>
                                            <Col className="text-right" xs="5" style={{ marginTop: distanceFromTop && distanceFromTop <= 0 ? 20 : 0, marginBottom: distanceFromTop && distanceFromTop <= 0 ? 20 : 0 }}>
                                                <button type="submit" className="btn btn-info btn-sm" onClick={formMethods.handleSubmit(onSave)}>{props.t("save")}</button>
                                                <button type="button" className="btn btn-default btn-sm" onClick={props.onCancel}>{props.t("cancel")}</button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            )}
                    </Sticky>
                </CardHeader>
                <CardBody>
                    {/*unitType === "POKA2" ||*/ isCompositeUnit ? <div style={{marginBottom:-40}}></div> : <Row style={{display:state_display}}>
                         <Col>
                             <CommonFields formMethods={formMethods} values={commonFieldValues} resourceId={props.resourceId} />
                         </Col>
                     </Row>}
                    <EditFields formMethods={formMethods} data={formData} resourceId={props.resourceId} showTagKeyButton={false} onNextButton = {onNextButton} onBackButton={onBackButton} />
                </CardBody>
            </Card>
        </form>
    );
}

function CommonFields({ formMethods, values, resourceId }) {
    const { register, errors, clearError } = formMethods
    const { title } = values;

    const fieldsForTitle = {
        text: {
            name: "title", label: t("title"), value: title,
            registerPayload: {
                required: false
            }
        },
    };

    return (
        <>
            <Row style={{ marginBottom: 20 }}>
                <Col>
                    <LocalizableTextField formMethods={formMethods} fields={fieldsForTitle} />
                </Col>
            </Row>
        </>
    );
}

export default withTranslation(uid)(SimpleUnitForm);
